/* eslint-disable jsx-a11y/control-has-associated-label */
import CloseIcon from '@mui/icons-material/Close';
import Modal from 'react-modal';
import { ICollaboratorViewModel } from 'viewModels';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/IconDelete.svg';
import { CompanyController } from '../../../controller/CompanyController';
import { Button } from '../../Buttons/Button';
import { ContentModal, Header } from './styles';

interface ModalDeleteCollaboratorProps {
  isOpen: boolean;
  runningTutorial: boolean;
  currentCollaborator: ICollaboratorViewModel;
  onRequestClose: () => void;
  onRequestRemoveCollaborator: () => void;
}

export function ModalDeleteCollaborator({
  onRequestRemoveCollaborator,
  currentCollaborator,
  runningTutorial,
  isOpen,
  onRequestClose,
}: ModalDeleteCollaboratorProps) {
  const handleDeleteCollaborator = () => {
    if (!runningTutorial) {
      CompanyController.deleteCollaborator(currentCollaborator.id).then(() => {
        onRequestRemoveCollaborator();
        onRequestClose();
      });
    } else {
      onRequestRemoveCollaborator();
      onRequestClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-delete-modal-content">
      <Header>
        <div className="subHeader">
          <DeleteIcon />
          <h1>Exclusão</h1>
        </div>
        <div className="close-div">
          <button type="button" onClick={onRequestClose}>
            <CloseIcon fontSize="small" />
          </button>
        </div>
      </Header>
      <ContentModal>
        <h2 className="confirmationText">Tem certeza que quer excluir o colaborador</h2>
        <p>{currentCollaborator.firstName}</p>
        <p>{currentCollaborator.email}</p>
        <div className="buttonModal">
          <Button
            text="Cancelar"
            dimensions={{ width: '13rem', height: '2.25rem' }}
            onClick={onRequestClose}
          />
          <Button
            text="Excluir"
            dimensions={{ width: '13rem', height: '2.25rem' }}
            onClick={handleDeleteCollaborator}
          />
        </div>
      </ContentModal>
    </Modal>
  );
}
